import React, { useState } from 'react';
import { toast } from 'sonner';
import { DatabaseBackup, Loader2 } from 'lucide-react';
import api from '@/utils/api';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const wait = (ms) => new Promise((r) => setTimeout(r, ms));

// «Descarregar cópia completa»: só admin, com confirmação; o servidor regista quem descarregou e envia email de aviso.
export const BackupDownload = () => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post('/admin/backup/export', { confirm: true });
      let st = { status: 'running' };
      while (st.status === 'running') { await wait(2000); st = (await api.get(`/admin/backup/${data.job_id}`)).data; }
      if (st.status !== 'ready') throw new Error(st.error || 'failed');
      const res = await api.get(`/admin/backup/${data.job_id}/download`, { responseType: 'blob', timeout: 0 });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `trabadju-copia-${new Date().toISOString().slice(0, 10)}.zip`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success(`Cópia descarregada: ${Object.keys(st.manifest?.collections || {}).length} colecções, ${st.manifest?.objects || 0} ficheiros`);
      setOpen(false);
    } catch (e) {
      toast.error('Não foi possível gerar a cópia.');
    } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-slate-200 bg-white p-4" data-testid="backup-card">
      <DatabaseBackup className="h-5 w-5 text-slate-600" />
      <div className="flex-1 min-w-[200px]">
        <p className="font-bold text-slate-900">Cópia de segurança completa</p>
        <p className="text-xs text-slate-500">Base de dados + CVs, logos e imagens num .zip. Guarde-o num local seguro e privado.</p>
      </div>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="backup-download-btn">Descarregar cópia completa</Button>
      {open && <Dialog open onOpenChange={(o) => !o && !busy && setOpen(false)}>
        <DialogContent className="max-w-md" data-testid="backup-confirm-dialog">
          <DialogHeader>
            <DialogTitle>Descarregar cópia completa?</DialogTitle>
            <DialogDescription>O ficheiro contém dados pessoais de candidatos e empresas (incluindo palavras-passe encriptadas). Fica registado quem descarregou e é enviado um email de aviso.</DialogDescription>
          </DialogHeader>
          <DialogFooter className="gap-2">
            <Button variant="outline" disabled={busy} onClick={() => setOpen(false)} data-testid="backup-cancel-btn">Cancelar</Button>
            <Button disabled={busy} onClick={run} data-testid="backup-confirm-btn">
              {busy ? <><Loader2 className="h-4 w-4 mr-1 animate-spin" />A preparar…</> : 'Confirmar e descarregar'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>}
    </div>
  );
};
